import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import * as MessageTypesConstants from '../constants/MessageTypesConstants';
import NotificationConstants from '../constants/NotificationConstants';
import { getSettingUrl } from '../routing/utils/externalUrls';
import * as ActionTypes from './ActionTypes';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.shared.notification';
function showNotificationWithMessage(actionType, actionIdentifer, isSticky, messageType, notificationType, message) {
  const titleText = unescapedText(`${I18N_PREFIX}.${notificationType}.title.${actionIdentifer}`);
  return dispatch => {
    dispatch({
      type: actionType,
      meta: {
        notification: {
          id: actionIdentifer,
          message,
          sticky: isSticky,
          titleText,
          type: messageType
        }
      }
    });
  };
}
function showNotification(actionType, actionIdentifer, isSticky, messageType, notificationType, options) {
  const message = unescapedText(`${I18N_PREFIX}.${notificationType}.message.${actionIdentifer}`, options);
  return showNotificationWithMessage(actionType, actionIdentifer, isSticky, messageType, notificationType, message);
}
export function showErrorNotification(actionIdentifer, options) {
  return showNotification(ActionTypes.SHOW_ERROR_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.ERROR, NotificationConstants.ERROR_NOTIFICATION, options);
}
export function showApiErrorNotification(actionIdentifer, message) {
  return showNotificationWithMessage(ActionTypes.SHOW_ERROR_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.ERROR, NotificationConstants.ERROR_NOTIFICATION, message);
}
export function showInfoNotification(actionIdentifer, options) {
  return showNotification(ActionTypes.SHOW_INFO_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.INFO, NotificationConstants.INFO_NOTIFICATION, options);
}
export function showSuccessNotification(actionIdentifer, options) {
  return showNotification(ActionTypes.SHOW_SUCCESS_NOTIFICATION, actionIdentifer, false, MessageTypesConstants.SUCCESS, NotificationConstants.SUCCESS_NOTIFICATION, options);
}
export function showErrorNotificationWithMessage(actionIdentifer, message) {
  return showNotificationWithMessage(ActionTypes.SHOW_ERROR_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.ERROR, NotificationConstants.ERROR_NOTIFICATION, /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }));
}
export function showTemplateSettingsPublishSuccessNotification(actionIdentifer, liveKnowledgeBaseUrl) {
  const message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: `${I18N_PREFIX}.success.message.templateSettingsPublished_jsx`,
    elements: {
      Button: ({
        children
      }) => /*#__PURE__*/_jsx(Button, {
        href: liveKnowledgeBaseUrl,
        size: "xs",
        target: "_blank",
        use: "tertiary",
        marginInlineStart: "200",
        children: children
      })
    }
  });
  return showNotificationWithMessage(ActionTypes.SHOW_SUCCESS_NOTIFICATION, actionIdentifer, false, MessageTypesConstants.SUCCESS, NotificationConstants.SUCCESS_NOTIFICATION, message);
}
export function showArticlePublishDomainNotResolvingErrorNotification() {
  const actionIdentifer = 'publishArticleDomainNotResolving';
  const message = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: `${I18N_PREFIX}.error.message.${actionIdentifer}_jsx`,
    elements: {
      Link: ({
        children
      }) => /*#__PURE__*/_jsx(Link, {
        href: getSettingUrl('general'),
        children: children
      })
    }
  });
  return showNotificationWithMessage(ActionTypes.SHOW_ERROR_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.ERROR, NotificationConstants.ERROR_NOTIFICATION, message);
}
export const removeNotification = id => ({
  type: 'REMOVE_NOTIFICATION',
  payload: {
    id
  }
});
export function showArticlePublishVariationCategoryNotSyncedErrorNotification() {
  const actionIdentifer = 'publishArticleVariationCategoryNotSynced';
  const message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${I18N_PREFIX}.error.message.publishArticleVariationCategoryNotSynced`
  });
  return showNotificationWithMessage(ActionTypes.SHOW_ERROR_NOTIFICATION, actionIdentifer, true, MessageTypesConstants.ERROR, NotificationConstants.ERROR_NOTIFICATION, message);
}